import axios from '@/zenky'

export default class CloudpaymentsProcessor {
  constructor(d, transaction, orderId, orderToken) {
    this.document = d
    this.transaction = transaction
    this.orderId = orderId
    this.orderToken = orderToken
    this.receipt = null
  }

  start() {
    return new Promise((resolve, reject) => {
      this.injectScriptIfNotAvailable()
        .then(() => this.loadTransactionReceipt())
        .then(receipt => {
          const widget = new window['cp']['CloudPayments']();
          const params = this.getParams(receipt)
          const chargeType = this.getChargeType()

          console.log('Charging via cloudpayments', {
            chargeType,
            params,
            receipt,
          })

          widget[chargeType](
            params,
            (params) => resolve(params),
            (reason, params) => reject({ params, reason })
          )
        })
        .catch(() => reject({
          params: this.transaction.transaction_meta.cloudpayments.widget,
          charge_type: this.getChargeType(),
          reason: 'Widget script is not available.',
        }));
    });
  }

  loadTransactionReceipt() {
    return new Promise(resolve => {
      axios.get(`orders/${this.orderId}/payments/${this.transaction.id}/receipt?token=${this.orderToken}`)
        .then(({ data }) => {
          this.receipt = data.data

          resolve(data.data)
        })
        .catch(err => {
          console.error('[CloudpaymentsProcessor@loadTransactionReceipt] Got error while trying to load transaction receipt.', {
            err,
            response: err.response ? err.response.data : null
          })

          resolve(null)
        })
    })
  }

  getParams(receipt) {
    if (!receipt) {
      return this.transaction.transaction_meta.cloudpayments.widget
    }

    const params = {
      ...this.transaction.transaction_meta.cloudpayments.widget,
    }
    params.data = params.data || {}
    params.data.cloudPayments = params.data.cloudPayments || {}
    params.data.cloudPayments.customerReceipt = receipt

    return params
  }

  getChargeType() {
    return this.transaction.transaction_meta.cloudpayments.charge_type || 'charge'
  }

  injectScriptIfNotAvailable() {
    return new Promise((resolve, reject) => {
      const existedScript = this.document.getElementById('cloudpayments-widget-script');

      if (existedScript) {
        return resolve();
      }

      let completed = false;

      const script = this.document.createElement('script');
      script.id = 'cloudpayments-widget-script';
      script.src = 'https://widget.cloudpayments.ru/bundles/cloudpayments';
      script.onload = () => {
        completed = true;
        resolve();
      };
      script.onerror = () => {
        completed = true;
        reject();
      };

      this.document.getElementsByTagName('head')[0].appendChild(script);

      // Allow up to 10 seconds for script to be loaded.
      // If script wasn't loaded even after 10 seconds,
      // reject promise & show error to the customer.

      setTimeout(() => {
        if (!completed) {
          reject();
        }
      }, 1000 * 10);
    });
  }
}
